import { useState } from 'react';
import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from 'react-query';
import { fetchBatches } from '../api/importService';
var PAGE_SIZE = 50;
/**
 * Hook for import batch list with simple offset pagination.
 * An error is reported as an error and an empty page as empty (CZNA-1344: this used to
 * fall back to invented mock rows, so a real import's detail could show errors it never had).
 */
var useImportBatchList = function () {
    var ky = useOkapiKy();
    var _a = useState(0), offset = _a[0], setOffset = _a[1];
    var _b = useQuery(['czna-import-batches', offset], function () { return fetchBatches(ky, { offset: offset, limit: PAGE_SIZE }); }, { keepPreviousData: true }), data = _b.data, isLoading = _b.isLoading, isFetching = _b.isFetching, isError = _b.isError, error = _b.error;
    return {
        items: (data === null || data === void 0 ? void 0 : data.items) || [],
        totalRecords: (data === null || data === void 0 ? void 0 : data.totalRecords) || 0,
        isLoading: isLoading,
        isFetching: isFetching,
        isError: isError,
        error: error,
        offset: offset,
        setOffset: setOffset,
        pageSize: PAGE_SIZE,
    };
};
export default useImportBatchList;
